import "../styles/css/login.css"
import "../styles/css/admin-style.css"
import {useContext, useEffect, useState} from "react";
import $ from "jquery";
import {AuthenticationHandler} from "../components/auth/AuthenticationHandler";
import {useNavigate} from "react-router-dom";
import {authService} from "../services/authService";
import NotificationService from "../services/NotificationService";
import eventEmitter from "../shared/eventEmitter";
import {EventEmitterTypes} from "../shared/eventEmitterEnum";

interface LoginData {
    email: string;
    password: string;
    confirmPassword: string;
}

const AdminLoginPage: React.FC = () => {
    // normal login: 1, reset pw: 2, set Password: 3
    const [activeForm, setActiveForm] = useState(1);
    const [loginData, setLoginData] = useState<LoginData>({ email: '', password: '', confirmPassword: '' });
    const auth = useContext(AuthenticationHandler);
    const navigate = useNavigate();
    useEffect(() => {
        // Attach the load event to fade out the pre-loader
        $(window).on('load', () => {
            $('.pre-loader').fadeOut('fast');
        });

        // Cleanup the event listener on unmount
        return () => {
            $(window).off('load');
        };
    }, []);

    useEffect(() => {
        document.body.classList.add("login-body");
        return () => document.body.classList.remove("login-body");
    }, []);

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        const success = await auth.login(loginData.email, loginData.password)
        if (success) {
            navigate('/admin/management');
            eventEmitter.emit(EventEmitterTypes.REFRESH_INFO)
        }
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setLoginData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleReset = async (event: React.FormEvent) => {
        event.preventDefault();
        try {
            await authService.forgotPassword(loginData.email)
            NotificationService.success("Reset password email sent successfully")
        } catch (error) {
            NotificationService.success("Reset password email sent successfully")
        }
    };

    return (
        <div className="loginBody">
        <div className="login-container text-center fullHeight">
            <div className="row d-flex align-items-center justify-content-center" style={{height: "100%"}}>

                <div className="lRight col-12">

                    {/*<!-- Login -->*/}
                    <div id="login" className={`loginDiv ${activeForm === 1 ? '' : 'hide'}`}>
                        <div className="logoContainer">
                            <img src="/logo/logo.svg" alt="Barreca logo" className="logo"/>
                        </div>
                        <div className="loginMessage">
                            <div className="messageHeader">Login</div>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <fieldset className="form-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control form-control-lg"
                                           placeholder="Email Address" name="email" value={loginData.email}
                                           onChange={handleChange} required/>
                                    <label className="login-label">Email Address</label>
                                </div>
                            </fieldset>
                            <fieldset className="form-group mt-3">
                                <div className="form-floating">
                                    <input type="password" className="form-control form-control-lg"
                                           placeholder="Password" name="password" value={loginData.password}
                                           onChange={handleChange} required/>
                                    <label className="login-label">Password</label>
                                </div>
                            </fieldset>
                            <fieldset className="mt-4">
                                <button type="submit"
                                        className="btn btn-lg btn-block btn-primary login-btn w-100 text-white shadow"
                                >Login
                                </button>
                                <button hidden type="button"
                                        className="btn btn-block btn-outline-primary login-btn">Create an Account
                                </button>
                                <div className="text-center mt-3">
                                    <button
                                        type="button"
                                        className="text-primary bg-transparent border-0 p-0"
                                        id="forgot-password-link"
                                        onClick={(e) => {
                                            setActiveForm(2)
                                        }}
                                        style={{cursor: "pointer",}}
                                    >
                                        <small>
                                            <i className="fa-regular fa-lock-keyhole"></i> Forgot your
                                            password?
                                        </small>
                                    </button>

                                </div>
                                <div className="text-center mt-3">
                                    <a className="text-primary" id="" href="/login"
                                       target="_self"><small><i className="fa-regular fa-globe"></i> Go to customer
                                        login</small></a>
                                </div>
                            </fieldset>
                        </form>
                    </div>


                    {/*!--Reset Password --*/}
                    <div id="reset-password" className={`loginDiv ${activeForm === 2 ? '' : 'hide'}`}>
                        <div className="logoContainer">
                            <img src="/logo/logo.svg" alt="Barreca logo" className="logo"/>
                        </div>
                        <div className="loginMessage">
                            <div className="messageHeader">Reset Password</div>
                        </div>
                        <form onSubmit={handleReset}>
                            <fieldset className="form-group">
                                <div className="form-floating">
                                    <input type="email" className="form-control form-control-lg"
                                           placeholder="Email Address" name="email" value={loginData.email}
                                           onChange={handleChange} required/>
                                    <label className="login-label">Email Address</label>
                                </div>
                            </fieldset>
                            <fieldset className="mt-4">
                                <button type="submit"
                                        className="btn btn-lg btn-block btn-primary login-btn w-100 text-white"
                                onClick={handleReset}>Send
                                    Reset
                                    Link
                                </button>
                            </fieldset>
                        </form>
                        <div className="login-links mt-3">
                            <button type="button"
                                    className="text-primary bg-transparent border-0 p-0"
                                    id="login-back-link"
                                    onClick={(e) => {
                                        setActiveForm(1);
                                        setLoginData({ email: '', password: '', confirmPassword: '' });
                                    }}
                                    style={{cursor: "pointer",}}><i
                                className="far fa-arrow-left"></i> back to
                                login
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
    );
};

export default AdminLoginPage;
